















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import * as modules from '../../../store/decorator'
import headers from '../../data/datatable-headers-history'
import axios from 'axios'
import { isOnline } from '../../../utils/services'
import { reject } from 'lodash'
import helperFormat from '../../mixins/HelperFormat.vue'

@Component({
    components: {
        vPurchaseOrder: () => import('../../components/shared/VPurchaseOrderSurvey.vue'),
        cctvHistoryIterator: () => import('../../components/shared/CCTVHistoryIterator.vue'),
        vLeafletMaps: () => import('../../components/shared/VLeafletMaps.vue'),
    }
})
export default class AssetLocator extends Vue {

  @Prop(Object) network!: any

  showAssetInfo: boolean = false;
  doNotTrack: boolean = false;
  geoLoaded = false;
  geoInterval: any;
  latitude = 0;
  longitude = 0;
  assetSearch = '';
  assetQuery = '';
  addressString = '';
  selectedAssetID = '';
  selectedType = '';
  networkCode = '';
  searchResults: any = null;
  showWW: boolean = true;
  showSW: boolean = false;
  activeTab = '';
  tabData = {};

  @Watch('network.code')
  onNetworkChange(value: string) {
    this.showAssetInfo = false;
    this.latitude = 0;
    this.longitude = 0;
    this.assetSearch = '';
    this.assetQuery = '';
    this.addressString = '';
    this.selectedAssetID = '';
    this.networkCode = '';
    this.activeTab = '';
    return this.networkCode = value;
  }

  mounted() {
    this.latitude = modules.user.customerDetail.latitude;
    this.longitude = modules.user.customerDetail.longtitude;
    if( navigator.geolocation ) {
      navigator.geolocation.getCurrentPosition(function () {}, function () {}, {});
      navigator.geolocation.getCurrentPosition(pos => {
        this.latitude = pos.coords.latitude;
        this.longitude = pos.coords.longitude;

        this.geoLoaded = true;
        clearInterval(this.geoInterval);
      }, err => {

      }, {maximumAge:60000, timeout: 2000, enableHighAccuracy:true});

      navigator.geolocation.watchPosition(pos => {
        if( this.latitude == 0 ) {
          if( !this.doNotTrack ) {
            this.latitude = pos.coords.latitude;
            this.longitude = pos.coords.longitude;
          }
        }
      }, err => {
      }, {enableHighAccuracy:true});
    } else {
      // eslint-disable-next-line
      console.log('geolocation not supported');
    }
  }

  get fullInfo() {
    return 'Asset No: ' + this.selectedAssetID + ' | Address: ' + this.addressString + ' | Coords: ' + this.latlng;
  }
  get latlng() {
    return this.latitude + ', ' + this.longitude;
  }

  pointClicked(value: any) {
    this.showAssetInfo = true;
    this.selectedAssetID = value.data.asset_id;
    this.latitude = value.latLng.lat;
    this.longitude = value.latLng.lng;
    this.selectedType = value.type ? ' - ' + value.type : '';
    this.addressString = '';
  }

  fetchData(value: any) {
    this.searchResults = value;
  }

  updateAddressString(value: any) {
    if( value.data.results.length > 0 ) {
      this.addressString = value.data.results[0].formatted_address;
    }
  }

  copyText(target: any) {
    var copyText = document.getElementById(target) as HTMLInputElement;

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /*For mobile devices*/

    /* Copy the text inside the text field */
    document.execCommand("copy");

    alert('copied to clipboard');
  }

  searchTimeout: any;

  async searchByAssetNo() {
    this.activeTab = '';
    this.assetQuery = this.assetSearch;
  }

  async WWChanged(isActive: any) {
    this.showWW = isActive.target.checked;
    this.assetQuery = this.assetSearch = this.activeTab = '';
    this.showAssetInfo = false;
  }
  async SWChanged(isActive: any) {
    this.showSW = isActive.target.checked;
    this.assetQuery = this.assetSearch = this.activeTab = '';
    this.showAssetInfo = false;
  }

  dataTabChanged(title: string, data: any) {
    if( this.activeTab != title ) {
      this.activeTab = title;
      this.tabData = data;
    }
  }
}
